/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_Requires_ValueInputs */

const cs_deal_splits_requires_value = /** @type {(inputs: Deal_Splits_Requires_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte procento nebo částku.`)
};

const en_deal_splits_requires_value = /** @type {(inputs: Deal_Splits_Requires_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a percent or an amount.`)
};

/**
* | output |
* | --- |
* | "Enter a percent or an amount." |
*
* @param {Deal_Splits_Requires_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_requires_value = /** @type {((inputs?: Deal_Splits_Requires_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Requires_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_requires_value(inputs)
	return cs_deal_splits_requires_value(inputs)
});